<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading full-character-formatting" epub:type="chapter" id="vol-1-chapter-1" role="doc-chapter">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">1</h1>
</div>
<h2 class="subtitle case-upper">DECEMBER 2010</h2>
</div>
</div>
</div>
<div class="text" id="vol-1-chapter-1-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><i>Attack is the best form of defence. Assisted by skill, cunning, and a whole lot of fucking luck.</i></p>
<p class="alignment-block-content alignment-block-content-center"><i>Advice given to new recruits of the 22nd Special Air Service Regiment.</i></p>
</div>
</div>
<hr class="implicit-break"/>
<p class="first first-in-chapter first-full-width first-with-first-letter-t"><span class="drop-cap">T</span>he weather didn’t matter. Not to Adam Black. Snow, hail, fog. Like clockwork, he went for his evening run. Whether it was habit or instinct or even enjoyment, he couldn’t be sure. Maybe insanity. But it was ingrained, second nature, down to the harshest training known to man, and so this particular evening was no different from any other. Except the moon. It was a blood moon, unobscured by cloud, surrounded by a million stars.</p>
<p class="subsq">“Unlucky,” Jennifer predicted, as she watched him tying up his trainers, a half smile playing on her lips.</p>
<p class="subsq">“Or maybe lucky.” Black laughed. “While I’m out, your lottery ticket might come up.”</p>
<p class="subsq">“Which would be nice, if I ever bought one.”</p>
<p class="subsq">“A major flaw. Let’s be honest. Having all that money would be… let me think. Boring? Who wants to be filthy rich, and live a life of shameful decadence and incredible luxury? Surely not you.”</p>
<p class="subsq">Jennifer ruffled his hair. “Of course not. Heaven forbid. I can barely imagine how awful it would be. Dinner’s going to be ready in half an hour. If you’re late, you’re looking at soggy pasta.”</p>
<p class="subsq">Black grinned.</p>
<p class="subsq">“Half an hour or soggy pasta. Put that on my headstone, please.”</p>
<p class="subsq">“I’d rather you put this on your head.” She handed him a black woollen mountain hat. “It’s minus two.”</p>
<p class="subsq">Black regarded the hat with scepticism. “Seriously?”</p>
<p class="subsq">“Seriously. I don’t want any husband of mine wandering about with frostbitten ears. Embarrassing. For me, that is. What would the neighbours say?”</p>
<p class="subsq">He shrugged – it was no use arguing – and put it on. Even with the hat, he cut a compelling figure. Unobtrusively muscular, handsome in a hard-bitten way, rather harsh cheekbones, dark eyes.</p>
<p class="subsq">“Tough guys shouldn’t need to wear hats like this.”</p>
<p class="subsq">“Which is precisely why you need to wear one. See you in half an hour, tough guy. Clock’s ticking.”</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001chapter001.vue?46594568